import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import EzContent from "../EzContent/EzContent.es.js";
import EzHeader from "../EzContent/EzHeader.es.js";
import stitches from "../theme.config.es.js";
import EzCardHeading from "./EzCardHeading.es.js";
const spacing = stitches.css({
  "&& > * + *": {
    marginTop: "$card-content-gap"
  }
});
const EzCardSection = ({ title, subtitle, actions, children, ...props }) => {
  const content = /* @__PURE__ */ jsx(EzContent, { ...spacing(props).props, children });
  return /* @__PURE__ */ jsx(Fragment, { children: !title ? content : /* @__PURE__ */ jsxs("section", { children: [
    /* @__PURE__ */ jsx(EzHeader, { children: /* @__PURE__ */ jsx(EzCardHeading, { ...{ actions, title, subtitle } }) }),
    content
  ] }) });
};
EzCardSection.displayName = "EzCardSection";
export {
  EzCardSection as default
};
//# sourceMappingURL=EzCardSection.es.js.map
